export const routes = {
  VAULT: '/vault',
  MGMT: '/',
};
